import { type UseQueryResult, useQuery } from 'react-query';
import {
  SwitchCompanyResponseDto,
  SwitchConfigurationService,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { OptionType } from '../../types/common';

const useGetCustomerSwitchableCompanies = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  OptionType[] | undefined,
  unknown
> => {
  const getCustomerSwitchableCompanies = useQuery(
    ['getCustomerSwitchableCompanies'],
    async () => {
      return await handleRequest(
        SwitchConfigurationService.getApiCustomerApiUserSwitchableCompaniesForUserSettingPage()
      );
    },
    {
      select: (data: SwitchCompanyResponseDto[] | undefined) => {
        return data?.map((company) => ({
          label: company.name,
          value: company.id,
        }));
      },
    }
  );

  return getCustomerSwitchableCompanies;
};

export default useGetCustomerSwitchableCompanies;
